import { useState } from "react";
import { toast } from "@/lib/toast";
import { useLanguage } from "@/contexts/LanguageContext";

export function useContact() {
  const { t } = useLanguage();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Simulate form submission
    await new Promise((resolve) => setTimeout(resolve, 1000));

    toast.success(t.contact.successToast, {
      description: t.contact.successDesc,
    });

    setName("");
    setEmail("");
    setMessage("");
    setIsSubmitting(false);
  };

  return {
    name,
    setName,
    email,
    setEmail,
    message,
    setMessage,
    isSubmitting,
    handleSubmit,
  };
}
